import { KeyWrapper as Key } from './Key';
import { KEY_BLOBS } from './constants';
import { KeyConfiguration, OnKeyPlayedFn } from './types';

type KeyboardProps = {
  keys?: KeyConfiguration[];
  onKeyPlayed?: OnKeyPlayedFn;
};

export function Keyboard({ onKeyPlayed, keys = KEY_BLOBS }: KeyboardProps) {
  return (
    <div className='flex flex-no-wrap max-w-full max-h-full h-full w-full items-center justify-center gap-0 flex-col sm:flex-row self-center'>
      {keys.map((keyBlob) => (
        <Key key={keyBlob.letter} {...keyBlob} onKeyPlayed={onKeyPlayed} />
      ))}
    </div>
  );
}
